import React from "react";
import { Row, Typography } from "antd";

import BreathingCalendar from "../Calendar/BreathingCalendar";

const { Title } = Typography;

const PatientBreathingTable = () => {
  return (
    <Row className="relative my-14 w-full">
      <BreathingCalendar />
    </Row>
  );
};

export default PatientBreathingTable;
